import React, { useEffect } from 'react'
import { useState } from 'react'
import Modal from '../../controls/Modal'
import LodingButton from '../../controls/LodingButton'
import { useFormik } from 'formik'
import Input from '../../controls/Input'
import * as yup from 'yup'


const schema = yup.object().shape({
    Comment: yup.string().required("Comment is required."),
    BloodPressure: yup.string().required("Blood Pressure is required"),
})

export default function ConfirmOnline({ isOpen, setIsOpen, id, ConfirmOnline, loding }) {

    const { values, handleBlur, handleChange, handleSubmit, errors, touched, isValid, setValues } = useFormik({
        initialValues: {
            Id: 0,
            Comment: "N/A",
            BloodPressure: "N/A",
        },
        enableReinitialize:true,
        validationSchema: schema,
        onSubmit(val) {
            ConfirmOnline(val, setValues)
        }
    })

    useEffect(() => {
        setValues({...values, Id:id})
    }, [id])

    return (
        <Modal isOpen={isOpen} setIsOpen={setIsOpen} title={"ConfirmOnline"}>
            <form onSubmit={handleSubmit}>
                <div class="p-6 space-y-6">
                    <div class="grid grid-cols gap-6">
                        <div class="col-span-12">
                            <label for="Comment" class="block mb-2 text-sm font-medium text-gray-900 ">Comment</label>
                            <Input placeholder="Comment"
                                type="text"
                                id="Comment"
                                Icon={"@"}
                                value={values.Comment}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.Comment && touched.Comment}
                            />
                            {errors.Comment && touched.Comment && <p className='text-red-600 text-xs'>{errors.Comment}</p>}
                        </div>

                        <div class="col-span-12 sm:col-span-6">
                            <label for="BloodPressure" class="block mb-2 text-sm font-medium text-gray-900 ">Blood Pressure</label>
                            <Input placeholder="BloodPressure"
                                id="BloodPressure"
                                type="text"
                                Icon={"@"}
                                value={values.BloodPressure}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.BloodPressure && touched.BloodPressure}
                            />
                            {errors.BloodPressure && touched.BloodPressure && <p className='text-red-600 text-xs'>{errors.BloodPressure}</p>}
                        </div>

                    </div>
                </div>
                <div class="flex items-center p-6 space-x-3 rtl:space-x-reverse border-t border-gray-200 rounded-b">
                    {!loding ?
                        <button type="submit" className={!isValid ? "btn-blue-disabled" : "btn-blue"} disabled={!isValid}>Save</button>
                        : <LodingButton text="Wait.." />
                    }
                </div>
            </form>
        </Modal>
    )
}
